module.exports = __webpack_public_path__ + "media/images/faces/female/22-3974fc3340d3d9d3600f64f6d9555887.jpg";